import React, { Fragment} from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import ToastMessage from "./Components/ToastMessage/ToastMessage";
import routes from "./Routes/Routes";
import fidduxTheme from "./theme/fidduxTheme";
import 'react-loading-skeleton/dist/skeleton.css'
import "./App.css";
const App = () => {
  return (
    <ThemeProvider theme={fidduxTheme}>
      <CssBaseline />
      <Fragment>
          <ToastMessage />
            <Routes>
              {routes.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.component}
                    exact={route.exact}
                    authenticate={route.authenticate}
                  />
                );
              })}
            </Routes>
      </Fragment>
    </ThemeProvider>
  );
};

export default App;
